module.exports = __webpack_public_path__ + "static/media/m-detective.2a60e147.png";